import { Star, BadgeCheck } from "lucide-react";

/**
 * TestimonialsGallerySlide - Shows a compact grid of testimonials inside the hero gallery
 */
export default function TestimonialsGallerySlide() {
  const testimonials = [
    {
      name: "James R.",
      text: "4 weeks in and I can already see new growth. My barber noticed before I even told him.",
      rating: 5,
      verified: true,
      initials: "JR",
      color: "bg-blue-500",
    },
    {
      name: "Michael T.",
      text: "Tried everything for 3 years. This is the only thing that actually worked. My crown is filling in.",
      rating: 5,
      verified: true,
      initials: "MT",
      color: "bg-emerald-500",
    },
    {
      name: "David L.",
      text: "No side effects unlike finasteride. And it actually works better. Wife noticed the difference.",
      rating: 5,
      verified: true,
      initials: "DL",
      color: "bg-purple-500",
    },
    {
      name: "Chris W.",
      text: "The micro-needle thing sounded weird but it's painless. 2 months in, hairline is coming back.",
      rating: 5,
      verified: true,
      initials: "CW",
      color: "bg-orange-500",
    },
  ];

  return (
    <div className="w-full h-full bg-[#0a1628] flex flex-col p-3 lg:p-4 overflow-hidden">
      {/* Header */}
      <div className="text-center mb-2 lg:mb-3">
        <div className="flex items-center justify-center gap-1 mb-1">
          {[1,2,3,4,5].map(i => (
            <Star key={i} className="w-3 h-3 lg:w-3.5 lg:h-3.5 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        <h3 className="text-white text-[10px] lg:text-xs font-bold uppercase tracking-wider">Real Results, Real People</h3>
      </div>

      {/* Testimonial cards */}
      <div className="flex-1 grid grid-cols-2 gap-1.5 lg:gap-2 min-h-0">
        {testimonials.map((t, idx) => (
          <div
            key={idx}
            className="bg-white/5 border border-white/10 rounded-lg p-2 lg:p-2.5 flex flex-col"
            style={{ animation: `fadeSlideIn 0.3s ease-out ${0.1 + idx * 0.1}s both` }}
          >
            {/* Avatar + Name */}
            <div className="flex items-center gap-1.5 mb-1.5">
              <div className={`w-5 h-5 lg:w-6 lg:h-6 rounded-full ${t.color} flex items-center justify-center text-white text-[7px] lg:text-[8px] font-bold flex-shrink-0`}>
                {t.initials}
              </div>
              <div className="flex items-center gap-1 min-w-0">
                <span className="text-white text-[8px] lg:text-[9px] font-semibold truncate">{t.name}</span>
                {t.verified && <BadgeCheck className="w-2.5 h-2.5 lg:w-3 lg:h-3 text-blue-400 flex-shrink-0" />}
              </div>
            </div>
            {/* Stars */}
            <div className="flex gap-0.5 mb-1">
              {[1,2,3,4,5].map(i => (
                <Star key={i} className="w-2 h-2 lg:w-2.5 lg:h-2.5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            {/* Text */}
            <p className="text-white/70 text-[7px] lg:text-[8px] leading-[1.4] line-clamp-4 flex-1">
              "{t.text}"
            </p>
          </div>
        ))}
      </div>

      {/* Bottom */}
      <div className="text-center mt-1.5 lg:mt-2">
        <span className="text-[8px] lg:text-[9px] text-white/40">Verified customer reviews</span>
      </div>
    </div>
  );
}

export function TestimonialsGalleryThumbnail() {
  return (
    <div className="w-full h-full bg-[#0a1628] flex flex-col items-center justify-center p-1">
      <div className="flex gap-0.5 mb-0.5">
        {[1,2,3,4,5].map(i => (
          <Star key={i} className="w-1.5 h-1.5 fill-yellow-400 text-yellow-400" />
        ))}
      </div>
      <div className="text-[5px] text-white/70 font-medium">Reviews</div>
      <div className="grid grid-cols-2 gap-0.5 mt-0.5">
        {[1,2,3,4].map(i => (
          <div key={i} className="w-2 h-2 rounded-sm bg-white/10" />
        ))}
      </div>
    </div>
  );
}
